<template>
  <li class="accordion__item">
    <div
      class="accordion__trigger"
      :class="{ accordion__trigger_active: visible }"
      @click="open"
    >
      <!-- This slot will handle the title/header of the accordion and is the part you click on -->
      <slot name="accordion-trigger"></slot>
    </div>

    <transition
      name="accordion"
      @enter="start"
      @after-enter="end"
      @before-leave="start"
      @after-leave="end"
    >
      <div class="accordion__content" v-show="visible">
        <ul>
          <!-- This slot will handle all the content that is passed to the accordion -->
          <slot name="accordion-content"></slot>
        </ul>
      </div>
    </transition>
  </li>
</template>

<script>
export default {
  props: {},
  inject: ["Accordion"],
  data() {
    return {
      index: null,
    };
  },
  computed: {
    visible() {
      return this.index == this.Accordion.active;
    },
  },
  methods: {
    open() {
      if (this.visible) {
        this.Accordion.active = null;
      } else {
        this.Accordion.active = this.index;
      }
    },
    start(el) {
      el.style.height = el.scrollHeight + "px";
    },
    end(el) {
      el.style.height = "";
    },
  },
  created() {
    this.index = this.Accordion.count++;
  },
};
</script>

<style lang="scss" scoped>
@import "./../../variables.scss";

.accordion__item {
  cursor: pointer;
  border-bottom: 1px solid $border;
  position: relative;
}

.accordion__trigger {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: $space-4;
  padding: $space-4 0;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.8;
  }

  :deep(h3) {
    margin: 0;
  }

  &::after {
    content: "+";
    flex-shrink: 0;
    font-family: fontSans_b;
    font-size: 24px;
    line-height: 1;
    color: $primary;
    transition: transform 0.2s ease;
  }
}

.accordion__trigger_active::after {
  transform: rotate(45deg);
}

.accordion__content {
  cursor: auto;

  > ul {
    margin: 0;
    padding: 0 0 $space-4;
    list-style: none;
  }
}

.accordion-enter-active,
.accordion-leave-active {
  will-change: height, opacity;
  transition: height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}

.accordion-enter-from,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}
</style>
